import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const VisibilityToggle = ({ label, isVisible, onToggle, children }) => {
  return (
    <div className="visibility">
      <div
        className="flex items-cente cursor-pointer"
        onClick={onToggle}
      >
        <FontAwesomeIcon
          icon={isVisible ? faEye : faEyeSlash}
          className={isVisible ? "text-green-600" : "text-red-600"}
        />
        <span className={isVisible ? "text-green-700" : "text-red-700"}>
          {isVisible ? "Visible to Public" : "Hidden from Public"}
        </span>
      </div>
      
      {children}
    </div>
  );
};

export default VisibilityToggle;
